module.exports = __webpack_public_path__ + "img/24c3fc9.png";